<style scoped>
    .search-item {
        margin-top : 0px;
        margin-bottom : 0px;
    }
    .item-td {
        cursor:pointer;
    }
    .second-row {
        display: flex;
        font-size: 15px;
    }
    .first-row {
        display: flex;
    }
    .sendTo {
        height: 20px;
        margin-right: 3%;
        text-align: center;
    }
    .from {
        width: 50px;
        background-color: lightgray;
    }
    .to {
        width: 30px;
        margin-left: 5%;
        color: white;
        background-color: gray;
    }

    .v-input--checkbox {
        margin-right: 30px;
    }
    .alert-row {
        display: flex;
        font-size: 13px;
        color: red;
    }
    .info-to{
        width: 50%;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
    }     
    .info-from{
        width: 250px;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
    }
    .count {
        font-size: 16px;
        text-align: left;
    }
    .page {
        font-size: 16px;
        text-align: right;
    }
    .approval{
        font-size: 14px;
        background-color: #F8CBAD;
        padding: 3px;
        border-radius: 8px;
    }
    .signature{
        font-size: 14px;
        background-color: #DAE3F3;
        padding: 3px;
        border-radius: 8px;
    }
    .white-space-nowrap{
        max-width: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
<template>
    <v-container fluid @click.left="menu = false">
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">要確認一覧</v-col>
            </v-row>
            <v-row>
                <v-col cols="12" xl="6" class="count">承認待ち件数{{ approval_count }}件 署名待ち件数{{ signature_count }}件</v-col>
                <v-col cols="12" xl="6" class="page">
                    <page_offset_limit_component :total="total" :items_per_page="itemsPerPage" :page="page"></page_offset_limit_component>
                </v-col>
            </v-row>
        </v-container>
        <v-row justify="center">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    :sort-by="['is_authorizer', 'is_cabinet']"
                    :sort-desc="[true, true]"
                    multi-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                            <tbody>
                                <tr v-for="(item, index) in props.items" :key="index" @click="itemAction(item.object_id)">
                                    <td class="item-td" align="center">
                                        <div v-html='item.is_authorizer ? "承認<br>待ち" : "署名<br>待ち"' :class="item.is_authorizer ? 'approval' : 'signature'"></div>
                                    </td>
                                    <td class="item-td white-space-nowrap" align="left">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span
                                                class="info-to"
                                                v-bind="attrs"
                                                v-on="on"
                                                >
                                                    {{ item.contract_name }}
                                                </span>
                                            </template>
                                            <span>{{ item.contract_name }}</span>
                                        </v-tooltip>
                                        <div class="second-row">
                                            <div class="sendTo to">To</div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span
                                                    class="info-to"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    >
                                                        {{ item.to_destination_user_names }}
                                                    </span>
                                                </template>
                                                <span>{{ item.to_destination_user_names }}</span>
                                            </v-tooltip>                                            
                                        </div>
                                        <template v-if="item.contract_error_status">
                                            <div class="alert-row">
                                                メールアドレスをご確認いただき再度送信頂くか、お問合せよりご連絡ください。
                                            </div>
                                        </template>
                                    </td>
                                    <td class="item-td white-space-nowrap" align="left">
                                        <div class="first-row">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span
                                                class="info-from"
                                                v-bind="attrs"
                                                v-on="on"
                                                >
                                                    {{ item.destination_company_name }} {{ item.first_update_name }} {{ item.first_update_email_address }}
                                                </span>
                                            </template>
                                            <span>{{ item.destination_company_name }} {{ item.first_update_name }} {{ item.first_update_email_address }}</span>
                                        </v-tooltip>
                                        </div>
                                        <div style="text-align: left;">{{ getDateWithWeekTimeText(item.first_signature_datetime) }}</div>
                                    </td>
                                    <td class="item-td white-space-nowrap" align="left">
                                        <div class="first-row">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span
                                                class="info-from"
                                                v-bind="attrs"
                                                v-on="on"
                                                >
                                                    {{ item.last_update_name }} {{ item.last_update_email_address }}
                                                </span>
                                            </template>
                                            <span>{{ item.last_update_name }} {{ item.last_update_email_address }}</span>
                                        </v-tooltip>
                                        </div>
                                        <div style="text-align: left;">{{ getDateWithWeekTimeText(item.last_signature_datetime) }}</div>
                                    </td>
                                </tr>
                            </tbody>
                    </template>
                </v-data-table>
            </v-col>
            <v-pagination
                v-model="page"
                :length="pageCount"
            ></v-pagination>
        </v-row>

    </v-container>
</template>
<script>
    import page_offset_limit_component from '../../components/common/PageOffsetLimitComponent.vue';
    import { dateformatMixin } from '../../mixins/dateformatMixin.js';
    export default {
        data() {
            return {
                // 承認待ち件数
                approval_count: 0,
                // 署名待ち件数
                signature_count: 0,
                // ページ数
                page: 1,
                // 最大ページ数
                pageCount: 0,
                // 1ページあたりの項目数
                itemsPerPage: 10,
                //総件数
                total:0,
                options: {},
                // テーブルヘッダー
                headers: [
                    { text: "", align: "center", width: "7%", sortable: false},
                    { text: "件名", value: "contract_name", align: "left", width: "33%", sortable: false},
                    { text: "最初の送信者", value: "", align: "left", width: "30%", sortable: false},
                    { text: "直近の送信者", value: "", align: "left", width: "30%", sortable: false},
                ],
            };
        },
        mixins: [dateformatMixin],
        components: {
            page_offset_limit_component,
        },
        props: {
            navi: [],
            items : Array
        },
        // 初期表示のデータ
        mounted() {
            this.setTotal();
        },
        methods: {
            // 契約書概要へのリンク
            itemAction(uid) {
                // 契約クリック時
                location.href = "/documents/document-management/summary/" + uid;
            },
            setTotal() {
                this.total = this.items.length;
                this.items.forEach((item) => {
                    if(item.is_authorizer == 0){
                        this.signature_count++;
                    }else if(item.is_authorizer == 1){
                        this.approval_count++;
                    }
                });
            },
        }
    };
</script>